import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { TarifsSection } from '../components/sections/TarifsSection';
import { FaqSection } from '../components/sections/FaqSection';
import { PageHeader } from '../components/sections/PageHeader';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import '../styles/home.css';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export default function TarifsPage() {
  return (
    <div className="home-container">
      <Helmet>
        <title>Tarifs Naturopathe Angoulême - Laura Body | Réflexologie, Massage</title>
        <meta name="description" content="Tarifs des consultations de Laura Body, naturopathe et réflexologue à Angoulême. Naturopathie 70€, réflexologie plantaire 65€, massage Shirotchampi 70€, Massage Rose Équilibre 80€, Pack Cutané 490€." />
        <link rel="canonical" href="https://www.naturopathe-angouleme.fr/tarifs" />
      </Helmet>

      <PageHeader />

      <section className="page-hero-mini">
        <div className="section-container">
          <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l'accueil</Link>
          <h1 className="page-hero-title">Tarifs - Laura Body Naturopathe à Angoulême</h1>
          <p className="page-hero-description">
            Retrouvez tous les tarifs des soins proposés par Laura Body à Angoulême : naturopathie, réflexologie plantaire, massage Shirotchampi, Massage Rose Équilibre et Pack Cutané.
          </p>
        </div>
      </section>

      <TarifsSection />
      <FaqSection />

      <section className="page-cta-section">
        <div className="section-container" style={{textAlign: 'center'}}>
          <h2 className="section-title">Réservez votre séance</h2>
          <p style={{marginBottom: '2rem', color: '#666'}}>Laura Body vous accompagne naturellement à Angoulême</p>
          <a href={BOOKING_URL} target="_blank">
            <Button className="btn-primary-hero">Réserver maintenant</Button>
          </a>
        </div>
      </section>
    </div>
  );
}
